import { DriveFolder } from "@shared/interfaces/CloudFiles";
import { ServerFile } from "@shared/interfaces/ProjectsFiles";
import React from "react";
import { ExternalFileData } from "./ExternalFilePreview";

const useGDrive = ({
  projectId,
  setGDriveFoldersLoading,
  setFolders,
  setExternalFilesData,
  setLoadingExternalFiles,
  gdriveService,
}: {
  projectId: string | undefined;
  setGDriveFoldersLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setFolders: React.Dispatch<React.SetStateAction<DriveFolder[]>>;
  setExternalFilesData: React.Dispatch<React.SetStateAction<ExternalFileData>>;
  setLoadingExternalFiles: React.Dispatch<React.SetStateAction<boolean>>;
  gdriveService: any;
}) => {
  // Fetch Google Drive folders and files for the project
  const fetchFolders = async () => {
    if (!projectId) return;

    try {
      setGDriveFoldersLoading(true);
      const data = await gdriveService.getProjectFolders(projectId);
      setFolders(data.folders);
    } catch (error) {
      console.error("Failed to fetch folders:", error);
    } finally {
      setGDriveFoldersLoading(false);
    }
  };

  const fetchFolderFiles = async (
    projectId: string,
    folderId: string
  ): Promise<ServerFile[]> => {
    try {
      const data = await gdriveService.getFolderFiles(projectId, folderId);
      return data.files as ServerFile[];
    } catch (error) {
      console.error("Failed to fetch folder files:", error);
      return [];
    }
  };

  const triggerGdriveFoldersRefresh = () => {
    fetchFolders();
  };

  const loadExternalFiles = async () => {
    if (!projectId) return;

    setLoadingExternalFiles(true);
    try {
      const fetched = await gdriveService.getExternalFiles(projectId, 0, 100);
      setExternalFilesData(fetched);
    } catch (err) {
      console.error("Failed to load external files:", err);
    } finally {
      setLoadingExternalFiles(false);
    }
  };

  return {
    fetchFolders,
    fetchFolderFiles,
    loadExternalFiles,
    triggerGdriveFoldersRefresh,
  };
};

export default useGDrive;
